import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BtnOrSelectWithPills from '../btn_or_select_with_pills';
import ModalSelect from '../modal_select';

class ModalWithButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: props.openModal,
    };

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect(element) {
    this.props.onSelect(element);
  }

  openModal() {
    this.setState({ openModal: true });
    if (this.props.onOpenModal) this.props.onOpenModal();
  }

  closeModal() {
    this.setState({ openModal: false });
    if (this.props.onCloseModal) this.props.onCloseModal();
  }

  render() {
    const {
      displayButton,
      displayPills,
      full,
      headerPhoto,
      iconClose,
      labelText,
      modalPrimaryText,
      modalSecondaryText,
      modalTitle,
      multi,
      onClearSelected,
      onRemovePills,
      onSubmit,
      options,
      placeholderText,
      selected,
      selectOptions,
      selectValue,
      smallModal,
      withoutBtnSelectSpaces,
    } = this.props;
    return (
      <div>
        <BtnOrSelectWithPills
          displayButton={displayButton}
          displayPills={displayPills}
          labelText={labelText}
          onRemovePills={onRemovePills}
          openModal={this.openModal}
          placeholderText={placeholderText}
          selected={selected}
          selectOptions={selectOptions}
          selectValue={selectValue}
          withoutBtnSelectSpaces={withoutBtnSelectSpaces}
        />
        {this.state.openModal && (
          <ModalSelect
            full={full}
            headerPhoto={headerPhoto}
            iconClose={iconClose}
            multi={multi}
            onClose={this.closeModal}
            onRemovePills={onRemovePills}
            onSelect={this.onSelect}
            onSubmit={onSubmit}
            options={options}
            primaryText={modalPrimaryText}
            resetSelectedElements={onClearSelected}
            secondaryText={modalSecondaryText}
            selected={selected}
            smallModal={smallModal}
            title={modalTitle}
          />
        )}
      </div>
    );
  }
}

ModalWithButtons.propTypes = {
  displayButton: PropTypes.bool,
  displayPills: PropTypes.bool,
  full: PropTypes.bool,
  headerPhoto: PropTypes.node,
  iconClose: PropTypes.bool,
  labelText: PropTypes.string,
  modalPrimaryText: PropTypes.string,
  modalSecondaryText: PropTypes.string,
  modalTitle: PropTypes.string,
  multi: PropTypes.bool,
  onClearSelected: PropTypes.func,
  onCloseModal: PropTypes.func, // additional functionality
  onOpenModal: PropTypes.func, // additional functionality
  onRemovePills: PropTypes.func,
  onSelect: PropTypes.func,
  onSubmit: PropTypes.func,
  openModal: PropTypes.bool,
  options: PropTypes.array,
  placeholderText: PropTypes.string,
  selected: PropTypes.array,
  selectOptions: PropTypes.array,
  selectValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  smallModal: PropTypes.bool,
  withoutBtnSelectSpaces: PropTypes.bool,
};

ModalWithButtons.defaultProps = {
  displayButton: false,
  displayPills: false,
  multi: false,
  openModal: false,
  withoutBtnSelectSpaces: false,
  smallModal: false,
};

export default ModalWithButtons;
